/* Tienda mentor: barra con reloj (solo fecha real), panel del menú, bolsa que abre el carrito lateral, garantías. */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  // Opiniones y estrellas de EJEMPLO: solo en la vista previa de un tema sin publicar. En el tema publicado no se muestran nunca.
  const role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
  // Copia de pruebas de Rubén (no se publica): opiniones y estrellas de ejemplo siempre visibles, sin restricción.
  $$('[data-lc-demo]').forEach((e) => { e.hidden = false; });
  $$('[data-lc-rev-track]').forEach((tr) => {
    const w = tr.closest('.lc-rev__wrap'), step = () => (tr.querySelector('.lc-rev__card')?.offsetWidth || 320) + 14;
    w.querySelector('[data-lc-rev-prev]')?.addEventListener('click', () => tr.scrollBy({ left: -step(), behavior: 'smooth' }));
    w.querySelector('[data-lc-rev-next]')?.addEventListener('click', () => tr.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  // Reloj de la barra: cuenta hasta la fecha real; al llegar, recarga para mostrar el texto sin campaña.
  const tk = $('[data-lc-ticker][data-end]');
  if (tk) {
    const end = new Date(tk.dataset.end).getTime();
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const d = Math.max(0, end - Date.now());
      const h = Math.floor(d / 36e5), m = Math.floor((d % 36e5) / 6e4), s = Math.floor((d % 6e4) / 1e3);
      const t = h >= 24 ? `${Math.floor(h / 24)}D ${pad(h % 24)}H ${pad(m)}M` : `${pad(h)}H ${pad(m)}M ${pad(s)}S`;
      $$('[data-lc-clock]', tk).forEach((c) => { c.textContent = t; });
      if (d === 0) { clearInterval(iv); setTimeout(() => location.reload(), 1500); }
    };
    const iv = setInterval(tick, 1000); tick();
  }

  // Panel del menú
  const nav = $('#lc-nav'), shade = $('[data-lc-shade]'), opener = $('[data-lc-open="lc-nav"]');
  const close = () => { nav.classList.remove('is-open'); shade.classList.remove('is-open'); document.documentElement.classList.remove('lc-lock'); opener?.setAttribute('aria-expanded', 'false'); setTimeout(() => { if (!nav.classList.contains('is-open')) { nav.hidden = true; shade.hidden = true; } }, 350); opener?.focus(); };
  const open = () => { nav.hidden = false; shade.hidden = false; requestAnimationFrame(() => { nav.classList.add('is-open'); shade.classList.add('is-open'); }); document.documentElement.classList.add('lc-lock'); opener.setAttribute('aria-expanded', 'true'); setTimeout(() => $('a, input', nav)?.focus(), 50); };
  if (nav && opener) {
    opener.addEventListener('click', open);
    $('[data-lc-close]', nav).addEventListener('click', close);
    shade.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && nav.classList.contains('is-open')) close(); });
  }

  // Cabecera fija: se compacta al bajar (con margen para que no parpadee en el límite)
  const hd = $('[data-lc-header]');
  if (hd) {
    const onScroll = () => { const y = window.scrollY; if (y > 60) hd.classList.add('is-scrolled'); else if (y < 20) hd.classList.remove('is-scrolled'); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Pestañas Mujer / Hombre del menú: abre en la del contenido que se está viendo; si no, la última elegida
  const tabs = $$('[data-lc-world-tab]');
  const showW = (w, focus) => {
    tabs.forEach((t) => { const on = t.dataset.lcWorldTab === w; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
    $$('[data-lc-world]').forEach((p) => { p.hidden = p.dataset.lcWorld !== w; });
    try { localStorage.setItem('lc-world', w); } catch (e) {}
  };
  if (tabs.length) {
    tabs.forEach((t) => {
      t.addEventListener('click', () => showW(t.dataset.lcWorldTab));
      t.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); showW(t.dataset.lcWorldTab === 'w' ? 'm' : 'w', true); } });
    });
    const menPage = /hombre|-men\b|\/men\b|t-shirts|shirts-polos|footwear-1|crossbody/.test(location.pathname) || document.querySelector('.lc-pills a[href*="new-in-men"]');
    let saved = null; try { saved = localStorage.getItem('lc-world'); } catch (e) {}
    showW(menPage ? 'm' : (saved || 'w'));
  }

  // La bolsa abre el carrito lateral (si existe); si no, va a /cart
  $$('[data-lc-cart]').forEach((a) => a.addEventListener('click', (e) => {
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { e.preventDefault(); drawer.open(); }
  }));
  // Contador de la bolsa al añadir
  document.addEventListener('cart:update', (e) => { const c = e.detail?.resource?.item_count ?? e.detail?.data?.itemCount; if (c == null) return; $$('[data-lc-count]').forEach((n) => { n.textContent = c; n.hidden = c === 0; }); });
  /* El tema emite ahora «shopify:cart:lines-update» (@shopify/events) y no «cart:update»: sin esto el número de la
     bolsa no cambiaba al sumar/quitar prendas en el carrito lateral. */
  const lcSetCount = (c) => $$('[data-lc-count]').forEach((n) => { n.textContent = c; n.hidden = c === 0; });
  document.addEventListener('shopify:cart:lines-update', (e) => {
    (e.promise || Promise.resolve()).then((r) => {
      const c = r?.cart?.totalQuantity ?? r?.detail?.itemCount;
      if (c != null) lcSetCount(c); else fetch('/cart.js').then((x) => x.json()).then((x) => lcSetCount(x.item_count)).catch(() => {});
    }).catch(() => {});
  });

  // Vistos recientemente: guarda la ficha visitada y los pinta en la página del carrito (solo en este navegador)
  const KEY = 'lc-recent';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
  const pdp = document.querySelector('[data-lc-pdp]');
  if (pdp) { const h = location.pathname.split('/products/')[1]?.split(/[/?#]/)[0]; if (h) { const l = [h, ...read().filter((x) => x !== h)].slice(0, 8); try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} } }
  const box = $('[data-lc-recent]');
  if (box) {
    const list = read().slice(0, 4);
    if (!list.length) box.closest('.lc-cartp__more').querySelector('.lc-sec-title').hidden = true;
    Promise.all(list.map((h) => fetch(`/products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null))).then((ps) => {
      box.innerHTML = ps.filter(Boolean).map((p) => `<div class="lc-card"><a class="lc-card__media" href="${p.url}"><img src="${p.featured_image}" alt="" loading="lazy"></a><a class="lc-card__title" href="${p.url}">${p.title.replace(/[<>&]/g, '')}</a></div>`).join('');
    });
  }

  // Fila de categorías: centra la actual
  $$('[data-lc-pills]').forEach((r) => { const on = $('.is-on', r); if (on) r.scrollLeft = on.offsetLeft - (r.clientWidth - on.offsetWidth) / 2; });

  // Garantías: puntos sincronizados
  $$('[data-lc-guar]').forEach((g) => {
    const tr = $('[data-lc-guar-track]', g), dots = $$('[data-lc-guar-dots] button', g);
    dots.forEach((d, i) => d.addEventListener('click', () => tr.scrollTo({ left: tr.clientWidth * i, behavior: 'smooth' })));
    tr.addEventListener('scroll', () => { const i = Math.round(tr.scrollLeft / tr.clientWidth); dots.forEach((d, k) => d.classList.toggle('is-on', k === i)); }, { passive: true });
    // Pasan solas cada 4 s en móvil, como en la referencia (se paran si el usuario interactúa o pide menos movimiento)
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches && dots.length > 1) {
      let i = 0, stop = false;
      ['pointerdown', 'touchstart', 'wheel'].forEach((ev) => tr.addEventListener(ev, () => { stop = true; }, { passive: true }));
      setInterval(() => { if (stop || tr.scrollWidth <= tr.clientWidth + 2) return; i = (Math.round(tr.scrollLeft / tr.clientWidth) + 1) % dots.length; tr.scrollTo({ left: tr.clientWidth * i, behavior: 'smooth' }); }, 4000);
    }
  });
})();

/* Colección · escalera de la oferta según lo que ya hay en el carrito (dato real de /cart.js) */
(() => {
  const box = document.querySelector('[data-lc-offer]');
  if (!box) return;
  const pct = { 2: box.dataset.l2, 3: box.dataset.l3, 4: box.dataset.l4 };
  const nudge = box.querySelector('[data-lc-offer-nudge]');
  const paint = (n) => {
    const lvl = n >= 4 ? 4 : n >= 2 ? n : 0;
    const next = n >= 4 ? 0 : Math.max(2, n + 1);
    box.querySelectorAll('[data-step]').forEach((li) => {
      const s = Number(li.dataset.step);
      li.classList.toggle('is-on', s === lvl);
      li.classList.toggle('is-next', s === next);
    });
    if (n >= 4) nudge.innerHTML = `Ya tienes el <strong>−${pct[4]} %</strong> máximo en el carrito.`;
    else if (n >= 1) {
      const add = next - n;
      nudge.innerHTML = `Llevas ${n} ${n === 1 ? 'prenda' : 'prendas'}: añade ${add} más y ${n >= 2 ? 'sube a' : 'consigue'} <strong>−${pct[next]} %</strong>.`;
    } else nudge.textContent = 'Se aplica automáticamente en el carrito.';
  };
  paint(Number(box.dataset.count) || 0);
  const refresh = () => fetch('/cart.js').then((r) => r.json()).then((c) => paint(c.item_count)).catch(() => {});
  document.addEventListener('cart:update', refresh);
  document.addEventListener('shopify:cart:lines-update', (e) => (e.promise || Promise.resolve()).then(refresh, refresh));
  window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
})();

/* Portada Mujer/Hombre · categorías en deslizable con flechas en ordenador */
document.querySelectorAll('[data-lc-cats]').forEach((row) => {
  const wrap = row.parentElement;
  const prev = wrap.querySelector('[data-lc-cats-prev]'), next = wrap.querySelector('[data-lc-cats-next]');
  const step = () => row.clientWidth * 0.8;
  const sync = () => {
    if (prev) prev.disabled = row.scrollLeft < 4;
    if (next) next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
  };
  prev?.addEventListener('click', () => row.scrollBy({ left: -step(), behavior: 'smooth' }));
  next?.addEventListener('click', () => row.scrollBy({ left: step(), behavior: 'smooth' }));
  // Indicación de deslizar: barra de progreso + «Desliza para ver todas» (se apaga al primer gesto)
  const sec = wrap.parentElement;
  const hint = sec.querySelector('[data-lc-swipe]'), bar = sec.querySelector('[data-lc-swipe-bar]');
  const paintBar = () => {
    if (!bar) return;
    const ratio = Math.min(1, row.clientWidth / row.scrollWidth);
    const max = row.scrollWidth - row.clientWidth;
    bar.style.width = `${ratio * 100}%`;
    bar.style.transform = `translateX(${max > 0 ? (row.scrollLeft / max) * ((1 - ratio) / ratio) * 100 : 0}%)`;
  };
  if (row.scrollWidth <= row.clientWidth + 4) { hint?.remove(); bar?.parentElement.remove(); }
  let done = false, nudging = false;
  row.addEventListener('scroll', () => { sync(); paintBar(); if (!done && !nudging && row.scrollLeft > 20) { done = true; hint?.classList.add('is-done'); } }, { passive: true });
  sync(); paintBar();
  // Pequeño empujón la primera vez que la fila entra en pantalla (solo móvil y sin «reducir movimiento»)
  if (matchMedia('(max-width: 989px)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      setTimeout(() => { if (row.scrollLeft > 0) return; nudging = true; row.scrollBy({ left: 70, behavior: 'smooth' }); setTimeout(() => { row.scrollTo({ left: 0, behavior: 'smooth' }); setTimeout(() => { nudging = false; }, 700); }, 650); }, 500);
    }, { threshold: 0.6 });
    io.observe(row);
  }
});
